import { Diagnostic } from "@fairfleet/geotab";
import { DiagnosticAddinData } from "../models/DiagnosticAddinData";

export default function combineDiagnosticsData(
  addinData: DiagnosticAddinData[],
  diagnosticData: Diagnostic[],
) {
  return diagnosticData.map(diagnostic => {
    const addIn = addinData.find(a => a.diagnosticId == diagnostic.id);

    return {
      id: diagnostic.id,
      source: diagnostic.source,
      name: diagnostic.name,
      priority: addIn && addIn.priority ? addIn.priority : 0,
      description: addIn && addIn.description ? addIn.description : "---",
      instruction: addIn && addIn.instruction ? addIn.instruction : "---",
    };
  });
}
